import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "@adeccoux/tag-ds/index.css";
import TostNotification from "../../util/tostNotification";
import DisplayButton from "../../util/displaybutton";
import {
    isIE,
    BrowserTypes,
    OsTypes,
    browserName,
    browserVersion,
    osName,
    osVersion,
    isFirefox,
} from "react-device-detect";
import {
    SYSCHECK_PHRASES,
} from '../../util/constants';
import { getCall } from '../../util/resources';
import SesHeader from "../header";

const Syscheck = ({ selectedLang }) => {
    const [tostNotification, setTostNotification] = useState(true);
    const [notificationData, setNotificationData] = useState(false);
    const [syscheckphrases, setSyscheckphrases] = useState({});
    const [loading, setLoading] = useState(false);

    let cookieEnabled = navigator.cookieEnabled;
    let language = navigator.language;
    let speed = 10;
    if (!isFirefox) {
        speed = navigator.connection.downlink;
    }
    const phrases = JSON.parse(sessionStorage.getItem("phrases"));
    const location = useLocation();

    const navigate = useNavigate();
    const [screenSize, setScreenSize] = useState(getCurrentDimension());
    function getCurrentDimension() {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    }
    const [ipAddress, setIPAddress] = useState("");

    function handelBack() {
        window.location.reload();
    }

    useEffect(() => {
        const initCall = async () => {
            try {
                setLoading(true);
                const [syscheckPhrase] = await Promise.all([
                    getCall(SYSCHECK_PHRASES + selectedLang),
                ]);
                console.log(syscheckPhrase.data.literals);
                setSyscheckphrases(syscheckPhrase.data.literals);
                setLoading(false);
            } catch (err) {
                console.log(err);
                navigate('/serverError');
            }
        };
        initCall();
    }, []);

    useEffect(() => {
        fetch("https://api.ipify.org?format=json")
            .then((response) => response.json())
            .then((data) => setIPAddress(data.ip))
            .catch((error) => console.log(error));

        showTostNotification(
            "Success",
            "Your system is correctly configured.",
            "success",
            "check"
        );
    }, []);

    const showTostNotification = (messageTitle, message, messageStatus, iconName) => {
        setTostNotification(true);
        setNotificationData({ messageTitle, message, status: messageStatus, iconName: iconName });
    };


    return (
        <>
            <SesHeader clientCobranding={location?.state?.clientCobranding} />
            <div className="flex_col g2 align-items_center xpert-align-self-stretch justify-content_center">
                <h3 className="xpert-align-self-stretch text-01">System Check</h3>
                <div className="flex g12 align-items_start xpert-align-self-stretch roundness_1">
                    <div className="flex_col g2 align-items_start xpert-align-self-stretch" style={{ flex: '1 0 0' }}>
                        {tostNotification && (
                            <TostNotification
                                notificationData={notificationData}
                            />
                        )}
                        <div className="flex_col align-items_start">
                            <div className="flex g1 align-items-center">
                                <div className="text-01 p3">
                                    {syscheckphrases?.['syscheck.label.system.value']}
                                </div>
                            </div>
                        </div>
                        <div className="flex_col g2 g1_mobile align-items_center xpert-align-self-stretch roundness_1 bg02 " style={{ border: '1px solid var(--borders_dividers-01, #EBEBEE)' }}>
                            <div className="flex_col align-items_start xpert-align-self-stretch">
                                <ul className="small" style={{ listStyle: 'none' }}>
                                    <li className="item-double bodyMediumSemibold ">
                                        {`${syscheckphrases?.['syscheck.label.javascript']} `}
                                        <span className="medium text-01">
                                            {` ${syscheckphrases?.['syscheck.label.enable']} `}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {`${syscheckphrases?.['syscheck.label.browser']} `}
                                        <span className="medium text-01">
                                            {` ${browserName} ${browserVersion}`}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {`${syscheckphrases?.['syscheck.label.browser.lang']} `}
                                        <span className="medium text-01">
                                            {` ${language}`}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {`${syscheckphrases?.['syscheck.label.screen.size']} `}
                                        <span className="medium text-01">
                                            {` ${screenSize.width} x ${screenSize.height} `}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.session.cookies']}
                                        <span className="medium text-01">
                                            {` ${syscheckphrases?.['syscheck.label.enable']} `}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.persistent.cookies']}
                                        <span className="medium text-01">
                                            {` ${syscheckphrases?.['syscheck.label.enable']} `}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.jvm']}
                                        <span className="medium text-01 syscheck_disabled">
                                            {` ${syscheckphrases?.['syscheck.label.disable']}`}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.os']}
                                        <span className="medium text-01">
                                            {` ${osName} ${osVersion}`}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.ip']}
                                        <span className="medium text-01">
                                            {` ${ipAddress} `}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.popup']}
                                        <span className="medium text-01">
                                            {` ${syscheckphrases?.['syscheck.label.disble']}`}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.connection.speed']}
                                        <span className="medium text-01">
                                            {` ${speed * 1024} KB/s`}
                                        </span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.proxy']}
                                        <span className="medium text-01"> no</span>
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.proxy.details']}
                                    </li>
                                    <li className="item-double bodyMediumSemibold">
                                        {syscheckphrases?.['syscheck.label.sound.card']}
                                        <span className="medium text-01">
                                            {` ${syscheckphrases?.['syscheck.label.enable']} `}
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div>
                            {syscheckphrases?.['syscheck.label.info.value']}
                        </div>
                    </div>
                </div>
            </div>
            <DisplayButton buttons={[<button className="button-secondary text_uppercase full-width_mobile" onClick={handelBack}>BACK</button>]} />
        </>
    );
};

export default Syscheck;
